/**
 * Загрузка моста MAX (https://st.max.ru/js/max-web-app.js) только при запуске
 * из MAX. Мост даёт window.WebApp: initData для входа, кнопку «назад», переход
 * в бота. Обычным тегом в index.html он грузился бы и в Telegram, и в браузере,
 * задерживая каждый запуск сторонним скриптом, поэтому подключается по
 * признаку MAX и до первого рендера.
 *
 * Признак запуска из MAX - параметр WebAppData во фрагменте URL
 * (dev.max.ru/docs/webapps/validation). Мост сам читает его оттуда же, а при
 * перезагрузке страницы - из sessionStorage (ключ WebAppData), так что
 * проверяем те же места.
 */

export const MAX_BRIDGE_URL = 'https://st.max.ru/js/max-web-app.js'

/** Сколько ждать мост, прежде чем показать приложение без него. */
const BRIDGE_TIMEOUT_MS = 5000

function hasWebAppData(hash: string | null | undefined): boolean {
  if (!hash) return false
  try {
    return new URLSearchParams(hash.replace(/^#/, '')).has('WebAppData')
  } catch {
    return false
  }
}

/** Мини-приложение запущено из MAX (по параметрам запуска, без моста). */
export function launchedFromMax(win: Window = window): boolean {
  if (hasWebAppData(win.location.hash)) return true
  try {
    const nav = win.performance?.getEntriesByType?.('navigation')[0] as PerformanceNavigationTiming | undefined
    if (nav && hasWebAppData(new URL(nav.name).hash)) return true
  } catch {
    // нет Performance API - смотрим дальше
  }
  try {
    return !!win.sessionStorage.getItem('WebAppData')
  } catch {
    return false
  }
}

/**
 * Подключить мост MAX, если приложение открыто из MAX. Промис всегда
 * выполняется: мост загрузился, не загрузился или не нужен. Без моста в MAX
 * вход не пройдёт (нет init data), и сервер ответит 401 - но экран не
 * зависнет навсегда.
 */
export function loadMaxBridge(win: Window = window, timeoutMs = BRIDGE_TIMEOUT_MS): Promise<void> {
  if ((win as Window & { WebApp?: unknown }).WebApp || !launchedFromMax(win)) {
    return Promise.resolve()
  }
  return new Promise((resolve) => {
    const script = win.document.createElement('script')
    const done = () => {
      win.clearTimeout(timer)
      resolve()
    }
    const timer = win.setTimeout(done, timeoutMs)
    script.src = MAX_BRIDGE_URL
    script.onload = done
    script.onerror = done
    win.document.head.appendChild(script)
  })
}
